import axios from 'axios';
import http from './HttpService';
import { objectToFormDataArray } from 'constants/utilityFunctions';
import { API_BASE_AUDIENCE } from 'constants/index';
import { IGetGlobalContactsParams, IDeleteGlobalContactsParams } from 'modules/Audience/interfaces2';
import { ICustomObjectType, ICustomType } from 'constants/interfaces/GlobalInterfaces';

let cancelTokenGlobalContacts: any;
export async function getGlobalContactsService(params: IGetGlobalContactsParams) {
  const payload = objectToFormDataArray(params as unknown as { [key: string | number]: ICustomType });
  //* Check if there are any previous pending requests
  if (typeof cancelTokenGlobalContacts != typeof undefined) {
    cancelTokenGlobalContacts && cancelTokenGlobalContacts.cancel('Operation canceled due to new request.');
  }
  //* Save the cancel token for the current request
  cancelTokenGlobalContacts = axios.CancelToken.source();
  return await http.post(
    `${API_BASE_AUDIENCE}get_people/`,
    payload,
    //Pass the cancel token to the current request
    { cancelToken: cancelTokenGlobalContacts.token },
  );
}

let cancelTokenOrganizations: any;
export async function getOrganizationsServiceNew(listId?: string, search?: string) {
  let url = `${API_BASE_AUDIENCE}get_all_organizations/`;
  if (listId || search) url += '?';
  if (listId) url += `list_id=${listId}`;
  if (search) url += `&search_organisation=${search}`;

  //* Check if there are any previous pending requests
  if (typeof cancelTokenOrganizations != typeof undefined) {
    cancelTokenOrganizations && cancelTokenOrganizations.cancel('Operation canceled due to new request.');
  }
  //* Save the cancel token for the current request
  cancelTokenOrganizations = axios.CancelToken.source();
  return await http.get(url, { cancelToken: cancelTokenOrganizations.token });
}

let cancelTokenDesignations: any;
export async function getDesignationsServiceNew(listId?: string, search?: string) {
  let url = `${API_BASE_AUDIENCE}get_all_designations/`;
  if (listId || search) url += '?';
  if (listId) url += `list_id=${listId}`;
  if (search) url += `&search_designation=${search}`;

  //* Check if there are any previous pending requests
  if (typeof cancelTokenDesignations != typeof undefined) {
    cancelTokenDesignations && cancelTokenDesignations.cancel('Operation canceled due to new request.');
  }
  //* Save the cancel token for the current request
  cancelTokenDesignations = axios.CancelToken.source();
  return await http.get(url, { cancelToken: cancelTokenDesignations.token });
}

// export audience contacts
let cancelTokenExportAudienceContacts: any;
export async function exportAudienceContactsNewService(params: ICustomObjectType, listId?: string) {
  const payload = objectToFormDataArray(params as unknown as { [key: string | number]: ICustomType });

  //* Check if there are any previous pending requests
  if (typeof cancelTokenExportAudienceContacts != typeof undefined) {
    cancelTokenExportAudienceContacts && cancelTokenExportAudienceContacts.cancel('Operation canceled due to new request.');
  }
  //* Save the cancel token for the current request
  cancelTokenExportAudienceContacts = axios.CancelToken.source();

  if (listId) {
    return await http.post(`${API_BASE_AUDIENCE}list_contacts/${listId}/`, payload, { cancelToken: cancelTokenExportAudienceContacts.token });
  } else {
    return await http.post(`${API_BASE_AUDIENCE}get_people/`, payload, { cancelToken: cancelTokenExportAudienceContacts.token });
  }
}

export async function deleteGlobalPeopleServiceNew(params: IDeleteGlobalContactsParams) {
  const {
    contactIds,
    deleteAll,
    excludedContactIds,
    listId,
    excludeListId,
    selectedOrganization,
    selectedDesignation,
    selectedPersonalityType,
    selectedStatus,
    searchTerm,
  } = params;

  const payload = new FormData();

  if (!deleteAll) {
    let contacts_ids = contactIds.join(',');
    payload.append('contact_ids', contacts_ids);
  }
  if (excludedContactIds.length > 0) {
    let unselected_ids = excludedContactIds.join(',');
    payload.append('exclude_contacts_delete', unselected_ids);
  }
  payload.append('delete_all', deleteAll.toString());
  payload.append('profiled', '-1');
  if (searchTerm && searchTerm.length > 0) {
    payload.append('search_by_name', searchTerm);
  }
  if (deleteAll) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonalityType !== undefined && selectedPersonalityType.length > 0) {
      payload.append('personality_type', selectedPersonalityType.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
  }

  if (listId) {
    payload.append('list_id', listId);
  }

  if (excludeListId) {
    payload.append('exclude_list', excludeListId);
  }

  return await http.post(`${API_BASE_AUDIENCE}delete_contact/`, payload);
}

export async function deleteListContactsServiceNew(params: IDeleteGlobalContactsParams) {
  const {
    listId,
    contactIds,
    deleteAll,
    excludedContactIds,
    selectedOrganization,
    selectedDesignation,
    selectedPersonalityType,
    selectedStatus,
    searchTerm,
  } = params;

  const payload = new FormData();

  if (!deleteAll) {
    let contacts_ids = contactIds.join(',');
    payload.append('contact_ids', contacts_ids);
  }

  if (excludedContactIds.length > 0) {
    let unselected_ids = excludedContactIds.join(',');
    payload.append('exclude_contacts_delete', unselected_ids);
  }

  payload.append('delete_all', deleteAll.toString());

  if (deleteAll) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonalityType !== undefined && selectedPersonalityType.length > 0) {
      payload.append('personality_type', selectedPersonalityType.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
    if (searchTerm !== undefined && searchTerm.length > 0) {
      payload.append('search_by_name', searchTerm);
    }
  }
  return await http.post(`${API_BASE_AUDIENCE}delete_list_contacts/${listId}/`, payload);
}

export async function deleteListService(listIds: number[]) {
  const payload = new FormData();

  if (listIds !== undefined && listIds.length > 0) {
    for (let id of listIds) {
      payload.append('list_ids', String(id));
    }
  }

  return await http.post(`${API_BASE_AUDIENCE}delete_list/`, payload);
}

export async function listAttachedWithWorkflowService(listIds: number[]) {
  const payload = new FormData();

  if (listIds !== undefined && listIds.length > 0) {
    payload.append('list_ids', listIds.join(','));
  }

  return await http.post(`${API_BASE_AUDIENCE}get_list_attached_workflows/`, payload);
}

export async function editListNameService(listId: string, newName: string) {
  const payload = new FormData();
  payload.append('list_name', newName);
  return await http.post(`${API_BASE_AUDIENCE}edit_list/${listId}/`, payload);
}

export async function addContactToListService(params: IDeleteGlobalContactsParams) {
  // contactIds: any,
  // listId?: string,
  // selectAllFlag?: boolean,
  // excludedIds?: any,
  // originalListId?: string,
  // fromPeopleTab?: boolean,
  // selectedOrganization?: string[],
  // selectedDesignation?: string[],
  // selectedPersonality?: string[],
  // selectedStatus?: string[],
  // searchTerm?: string,
  // fromGloabalListing?: boolean,
  const {
    listId,
    contactIds,
    deleteAll,
    excludedContactIds,
    selectedOrganization,
    selectedDesignation,
    selectedPersonalityType,
    selectedStatus,
    searchTerm,
  } = params;

  console.info(params);

  const payload = new FormData();

  if (listId && listId !== '') {
    payload.append('list_id', listId);
  }
  // add contact ids in payload. Previous:if (contactIds?.length > 0 && !selectAllFlag)
  if (contactIds?.length > 0) {
    for (let item of contactIds) {
      payload.append('contact_ids', item.toString());
    }
  }

  if (deleteAll) {
    payload.append('select_all', deleteAll.toString());
  }

  if (excludedContactIds?.length > 0) {
    for (let item of excludedContactIds) {
      payload.append('excluded_contacts_list', item.toString());
    }
  }

  // if (!fromGloabalListing) {
  //   originalListId && payload.append('original_list_id', originalListId.toString());
  // } else {
  //   originalListId && payload.append('exclude_list_id', originalListId.toString());
  // }

  // if (fromPeopleTab) {
  //   payload.append('from_people_tab', fromPeopleTab.toString());
  // }

  payload.append('from_people_tab', 'true');

  if (searchTerm !== undefined && searchTerm !== '') {
    payload.append('search_by_name', searchTerm);
  }

  if (deleteAll) {
    if (selectedOrganization !== undefined && selectedOrganization.length > 0) {
      for (let organization of selectedOrganization) {
        payload.append('filter_by_organization', organization);
      }
    }

    if (selectedDesignation !== undefined && selectedDesignation.length > 0) {
      for (let designation of selectedDesignation) {
        payload.append('filter_by_designation', designation);
      }
    }

    if (selectedPersonalityType !== undefined && selectedPersonalityType.length > 0) {
      payload.append('personality_type', selectedPersonalityType.join(','));
    }

    if (selectedStatus !== undefined && selectedStatus.length > 0) {
      payload.append('status', selectedStatus.join(','));
    }
  }

  return await http.post(`${API_BASE_AUDIENCE}create_list/`, payload);
}

export const getScheduledEmailList = async (listId: number) => {
  return await http.get(`${API_BASE_AUDIENCE}get_list_scheduled_emails/?list_id=${listId}`);
};
